module.exports = __webpack_public_path__ + "static/Truck15-8e3fe19dad063727b1d07482f134f738.png";